export default __webpack_public_path__ + "static/media/Helm of the First Circle.8155fd54.jpg";